import React from "react";
import topper1 from "../../assets/topper1.png";
import topper2 from "../../assets/topper2.png";
import topper3 from "../../assets/topper3.png";

const toppers = [
  {
    name: "Shivam Kumar",
    state: "Bihar",
    score: "BSEB Class 10 — 95.4%",
    rank: "Bihar State Board · Rank 8",
    image: topper1,
  },
  {
    name: "Afreen Khatun",
    state: "Madhya Pradesh",
    score: "MPBSE Class 10 — 97.75%",
    rank: "Anuppur District · Rank 2",
    image: topper2,
  },
  {
    name: "Sushant Kumar Das",
    state: "Jharkhand",
    score: "JAC Class 10 — 93.80%",
    rank: "Sonahatu Block · Rank 1",
    image: topper3,
  },
];

const TopperGrid = () => {
  return (
    <section
      aria-label="Toppers who studied with Pathyacharya"
      className="py-14 px-4 bg-white"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Pathyacharya से पढ़ने वाले Toppers
          </h2>
          <p className="mt-2 text-gray-600">
            असली बच्चे, असली बोर्ड परीक्षाएं, असली नतीजे।
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {toppers.map((t) => (
            <div
              key={t.name}
              className="flex flex-col items-center text-center bg-gray-50 rounded-2xl p-6 border border-gray-200"
            >
              <img
                src={t.image}
                alt={`${t.name} — ${t.score}`}
                className="w-28 h-28 sm:w-32 sm:h-32 rounded-full object-cover ring-4 ring-blue-100"
                loading="lazy"
              />
              <h3 className="mt-4 font-semibold text-gray-900">{t.name}</h3>
              <p className="text-sm text-gray-600">{t.state}</p>
              <p className="mt-2 font-bold text-blue-700">{t.score}</p>
              <p className="text-xs text-gray-500 mt-1">{t.rank}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopperGrid;
